import { isProfileLoadedFromApi, checkFeatureFlagAccess } from './featureFlagGuardUtils';

/**
 * Testable function for leaderboard route access.
 * Returns '/lms' to redirect, or undefined to allow access.
 */
export const checkLeaderboardAccess = (): string | undefined => {
   return checkFeatureFlagAccess('show_leaderboard');
};

/**
 * Middleware to protect the Leaderboard route when the brand has not enabled it.
 *
 * Gated on show_leaderboard rather than on nav visibility, unlike the other feature
 * guards. An admin hiding the menu entry should not make the page unreachable - the
 * API stays available in that case, so the route should too. Brands that never enable
 * the feature have no flag and are redirected.
 */
export default defineNuxtRouteMiddleware(() => {
   if (!isProfileLoadedFromApi()) {
      return;
   }

   const redirect = checkLeaderboardAccess();

   if (redirect) {
      return navigateTo(redirect);
   }
});
